
import Component from "vue-class-component";
import Vue from "vue";
import TruckModule from "@/store/modules/truck";
import {getModule} from "vuex-module-decorators";
import {Truck} from "../../models/api/trucks/getTrucks";
import notifications from "../../lib/notifications";
import {Prop, Emit, Watch} from "vue-property-decorator";
import {DriverResource} from "../../models/api/drivers/get";
import Select from "@/components/form/Select.vue";
import { getTruckCubeWarningLevel } from "@/store/modules/truck/helpers";
import { formatBool } from "@/utils";
import TruckCommodity from "@/components/truck/TruckCommodity.vue";

const truckModuleState = getModule(TruckModule);

@Component({
  components: {TruckCommodity, Select}
})

export default class TruckHeader extends Vue {
  @Prop({required: false, default: () => []})
  drivers: DriverResource[];
  saving: boolean = false;
  promtDeliveryDateChanged: boolean = false;
  showDeliveryDateChangePrompt: boolean = false;
  truckCommoditySummary: any = [];

  async created() {
    this.truckCommoditySummary = await truckModuleState.getTruckCommoditySummary(this.currentTruck.id);
  }

  async save() {
    if (this.promtDeliveryDateChanged)
      this.showDeliveryDateChangePrompt = true;
    else {
      this.saving = true;

      try {
        const response = await truckModuleState.updateTruck();
        notifications.success("Truck update", "Truck successfully updated");
        this.$emit("onTruckSaved");
      } catch (ex) {
        notifications.error("Truck update", "Failed to save truck updates.", ex);
      }

      this.saving = false;
    }
  }

  async confirmDeliveryDateChange() {
    this.promtDeliveryDateChanged = false;
    this.showDeliveryDateChangePrompt = false;
    await this.save();
  }

  closeDeliveryDateChangePrompt() {
    this.showDeliveryDateChangePrompt = false;
  }

  get currentTruck(): Truck {
    return truckModuleState.currentTruck;
  }

  get name() {
    return truckModuleState.currentTruck.name;
  }

  set name(val) {
    truckModuleState.setTruckName(val);
  }

  get deliveryDate() {
    return truckModuleState.currentTruck.deliveryDate;
  }

  set deliveryDate(val) {
    truckModuleState.setDeliveryDate(val);
  }

  get zip3sServiced() {
    return truckModuleState.currentTruck.zip3sServiced;
  }

  get totalUnits() {
    return truckModuleState.currentTruck.totalUnits;
  }

  get weight() {
    return truckModuleState.currentTruck.weight;
  }

  set zip3sServiced(val) {
    truckModuleState.setZips(val);
  }

  get status() {
    return truckModuleState.currentTruck.status;
  }

  set status(val) {
    truckModuleState.setTruckStatus(val);
  }

  get driverId() {
    return truckModuleState.currentTruck.driverId;
  }

  set driverId(val) {
    truckModuleState.setDriverId(val);
  }

  get driverPhoneNumber() {
    return truckModuleState.currentTruck.driverPhoneNumber;
  }

  set driverPhoneNumber(val) {

  }

  get tripDays() {
    return truckModuleState.currentTruck.tripDays;
  }

  set tripDays(val) {
    truckModuleState.setTripDays(val);
  }

  get maxCubes() {
    return truckModuleState.currentTruck.maxCubes;
  }

  set maxCubes(val) {
    truckModuleState.setMaxCubes(val);
  }

  get cubesUsed() {
    return truckModuleState.currentTruck.cubesUsed;
  }

  set cubesUsed(val) {
  }

  get availableCubes() {
    return truckModuleState.currentTruck.availableCubes;
  }

  set availableCubes(val) {
  }

  get stopsPlaceHolder()
  {
    if(this.isFinalized)
      return  "# of Stops:";
    return "# of Orders:";
  }

  get stops() {
    return truckModuleState.currentTruck.stops;
  }

  set stops(val) {
  }

  get totalMiles() {
    return truckModuleState.currentTruck.totalMiles;
  }

  set totalMiles(val) {
  }

  get showMiles() {
    return truckModuleState.currentTruck.totalMiles != null && truckModuleState.currentTruck.isFinalized;
  }

  get isFinalized() {
    return truckModuleState.currentTruck.isFinalized;
  }

  set isFinalized(val) {
  }

  get availableDrivers() {
    if (!this.drivers) return [];
    return this.drivers.map(x => ({label: x.driverName, value: x.id}));
  }

  get allOrdersReceived() {
    return this.currentTruck.orders.filter(x => !x.isReceived).length == 0;
  }

  set allOrdersReceived(value) {

  }

  getCubeWarningClass() {
    let warningLevel = this.getWarningLevel();
    return "truck-cube-warning-" + warningLevel.toString();
  }

  getWarningLevel() {
    return getTruckCubeWarningLevel(
      truckModuleState.currentTruck.cubesUsed,
      truckModuleState.currentTruck.maxCubes
    );
  }

  formatBool(value) {
    return formatBool(value);
  }

  @Watch("deliveryDate")
  deliveryDateChanged(newVal, oldVal) {
    if (newVal != oldVal)
      this.promtDeliveryDateChanged = true;
  }

}
